// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eft-deposit-container {
  width: 98%;
  height: 98%;
  margin: 1%;
  border: none;
}
.embedded-checkout-container {
  width: 98%;
  height: 98%;
  margin: 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.embedded-checkout-container .checkout-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  gap: 20px;
}
.embedded-checkout-container .checkout-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: 16px;
  text-align: center;
}
.embedded-checkout-container .error-message {
  font-family: Jost, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #d32f2f;
  margin: 0;
}
.embedded-checkout-container .retry-button {
  font-family: Jost, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 24px;
  background-color: #fbbc05;
  color: #000000;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.embedded-checkout-container .retry-button:hover {
  background-color: #e5ac00;
}
.embedded-checkout-container .peach-checkout-form {
  width: 100%;
  height: 100%;
  min-height: 360px;
}
iframe {
  width: 100%;
  height: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
